import { cn } from '@/app/utils';

interface BannerAvatarCardSkeletonProps {
  className?: string;
}

export function BannerAvatarCardSkeleton({ className }: BannerAvatarCardSkeletonProps) {
  return (
    <div className={cn('relative aspect-[3/4] w-[158px] shrink-0 sm:w-[calc(50%-2px)]', className)}>
      <div className="h-full w-full animate-pulse rounded-16 border border-system-white08 bg-white/10" />
    </div>
  );
}
